module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "section",
    attrs: {
      "id": "sect6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/toc#sect6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oatmeal Coffee Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    staticStyle: {
      "height": "70vh"
    },
    attrs: {
      "alt": "",
      "src": "OEBPS/images/14-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "RecipebYieldb"
  }, [_vm._v("Yield: Serves 4–6 | Prep Time: 10 minutes | Cook Time: 25–30 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "extract_r"
  }, [_vm._v("Coffee cake always marked a special occasion growing up. If we were expecting overnight guests, my dad would pick up a coffee cake from the local bakery to serve in the morning alongside some freshly brewed coffee. It was such a fun treat, and with this lightened-up version, I don’t have to wait for a special occasion to indulge!")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_c('strong', [_vm._v("INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ cup coconut oil, plus 1 tablespoon")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("2 large eggs")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1¼ cups packed light brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 cup cooked oatmeal, cooled")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 teaspoon vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("¾ cup whole wheat flour")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("¾ cup all-purpose flour")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ teaspoon kosher salt")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1½ teaspoons cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 teaspoon baking soda")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1½ cups blueberries")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("¼ cup chopped walnuts")]), _vm._v(" "), _c('p', {
    staticClass: "directions"
  }, [_c('strong', [_vm._v("DIRECTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("1. Preheat the oven to 350°F. Lightly coat an 8 × 8-inch baking dish with cooking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("2. In a large bowl, combine ½ cup of the coconut oil, the eggs, 1 cup of the brown sugar, the oatmeal, and the vanilla.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("3. In a medium bowl, whisk together the whole wheat flour, all-purpose flour, salt, 1 teaspoon of the cinnamon, and the baking soda.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("4. Combine the dry ingredients with the wet and stir until combined.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("5. Gently fold in the blueberries.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("6. Pour into the baking dish.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("7. In a small bowl, mix together the remaining 1 tablespoon coconut oil, ¼ cup brown sugar, and ½ teaspoon cinnamon with the walnuts. Evenly sprinkle the mixture over the top of the cake.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("8. Bake for 25 to 30 minutes until the cake is set.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("9. Let the cake cool before cutting. Serve.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-094c48f1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/sect6.vue
// module id = 102
// module chunks = 0